import TipoDocumento from "./TipoDocumento";

export class Documento {
  constructor() {
    this.TipoDocumento = new TipoDocumento();
    this.NombreArchivo = "";
    this.ArchivoBase64 = "";
    this.EsValido = false;
    this.Errores = [];
  }

  TipoDocumento: TipoDocumento;
  NombreArchivo: string;
  ArchivoBase64: string;
  EsValido: boolean;
  Errores: any;
}
